import styled from "styled-components";
import { motion } from "framer-motion";

export const CardDisplayContainer = styled(motion.div)`
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    position: relative;
`
export const ImgContainer = styled.div`
    align-items: center;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    background: ${({ $hasAssignedCard, $hasUploadedImage, $isActive }) => {
        if (!$hasAssignedCard) return "rgba(255, 255, 255, 0.1)";
        if ($isActive || !$hasUploadedImage) return "rgba(255, 255, 255, 0.33)";
        return "rgba(255, 255, 255, 0.1)";
    }};
    border: ${props => props.$isActive ? "2px solid rgba(255, 255, 255, 0.4)" : "none"};
    box-sizing: border-box;
    display: flex;
    height: 88px;
    justify-content: center;
    width: 64px;
    transition: transform 0.3s ease;
    transform: ${({ $imageOrientation }) => 
        $imageOrientation === "horizontal" ? "rotate(90deg)" : "none"};

    img {
        height: ${({ $hasUploadedImage }) => $hasUploadedImage ? '100%' : 'auto'};
        object-fit: ${({ $hasUploadedImage }) => $hasUploadedImage ? 'cover' : 'contain'};
        opacity: ${({ $hasUploadedImage }) => $hasUploadedImage ? '1' : '0.4'};
        width: ${({ $hasUploadedImage }) => $hasUploadedImage ? '100%' : '40%'};
    }
`

export const PositionContainer = styled.div`
    font-weight: 500;
`